import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '../../../core/store/authentication/authentication.store';
import { injectDispatch } from '@ngrx/signals/events';
import { authApiEvents } from '../../../core/store/authentication/authentication.events';
import { ProviderStore } from '../../../core/store/provider/provider.store';
import { FeeScheduleStore } from '../../../core/store/fee-schedule/fee-schedule.store';
import { ClinicStore } from '../../../core/store/clinic/clinic.store';
import { ClinicAdminStore } from '../../../core/store/clinic/clinic-admin.store';
import { ClinicLocationStore } from '../../../core/store/clinic/clinic-location.store';
import { MemberStore } from '../../../core/store/member/member.store';

@Component({
    standalone: true,
    selector: 'app-navbar',
    imports: [],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  store = inject(AuthStore)
  clinicStore = inject(ClinicStore)
  clinicAdminStore = inject(ClinicAdminStore)
  clinicLocationStore = inject(ClinicLocationStore)
  providerStore = inject(ProviderStore)
  feeScheduleStore = inject(FeeScheduleStore)
  memberStore = inject(MemberStore)
  readonly dispatch = injectDispatch(authApiEvents)

  $loggedIn !: boolean

readonly router = inject(Router);

  logout() {
    this.store.clear()
    this.clinicStore.clear()
    this.clinicAdminStore.clear()
    this.clinicLocationStore.clear()
    this.providerStore.clear()
    this.feeScheduleStore.clear()
    this.memberStore.clear()
    this.dispatch.logout(true)
  }
}
